import React from "react";
import {
  Grid,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PasswordValidator from "password-validator";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AuthContext from "../../../contexts/AuthContext";
import { confirmForgot } from "../../../utilities/authFlow";

import "./AuthStyle.css";
import logo from "../../../assets/tnfmlogo.png";

const ConfirmForgot = ({ setPage }) => {
  const theme = useTheme();
  const { email, setEmail, setSignedIn } = React.useContext(AuthContext);
  const [password, setPassword] = React.useState("");
  const [password2, setPassword2] = React.useState("");
  const [code, setCode] = React.useState("");
  const [passwordVisibility, setPasswordVisibility] = React.useState(false);
  const [error, setError] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(null);
  const [passwordConfirmError, setPasswordConfirmError] = React.useState(null);
  const [codeError, setCodeError] = React.useState(null);

  const validatePassword = () => {
    console.log("validating password");
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8, "Password is too short - min 8")
      .has()
      .uppercase(1, "At least 1 uppercase letter required")
      .has()
      .lowercase(1, "At least 1 lowercase letter required")
      .has()
      .digits(1, "At least 1 number required")
      .has()
      .symbols(1, "At least 1 symbol required");

    const valid = schema.validate(password, { details: true });
    console.log(`password valid: ${valid}`);
    if (valid.length > 0) {
      setPasswordError(valid[0].message);
      return;
    }
    if (valid.length === 0 && passwordError) {
      setPasswordError(null);
    }
  };

  const validatePasswordConfirm = () => {
    console.log("validating password confirm");
    if (password !== password2) {
      setPasswordConfirmError(true);
    } else {
      setPasswordConfirmError(null);
    }
  };

  const handleReset = async () => {
    if (passwordError || passwordConfirmError) {
      return;
    }

    try {
      const result = await confirmForgot(email, password, code);
      if (result.success) {
        setError(null);
        setCodeError(null);
        setSignedIn(true);
      } else {
        if (result.error == "Invalid code. Please try again.") {
          setCodeError(result.error);
        } else {
          setError(result.error);
        }
      }
    } catch (e) {
      var error = `Error resetting password. Error: ${e.message}`;
      console.error(error);
      setError(error);
    }
  };

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      style={{
        height: "100%",
        backgroundColor: "#cfc9bc",
        fontFamily: "Instrument Sans, sans-serif",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={logo} height="150px" />
        <Typography variant="h6">
          The Next Fun <span style={{ color: "#e6ff02" }}>Match</span>
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        lg={5}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <form
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Paper
            elevation={3}
            style={{ width: "100%", padding: 10, backgroundColor: "#11190c" }}
          >
            <Grid container direction="column" spacing={3}>
              <Grid item style={{ marginTop: 20 }}>
                <Typography
                  variant="h5"
                  align="center"
                  style={{ color: "white" }}
                >
                  Create a new password
                </Typography>
              </Grid>
              <Grid item style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                <Typography
                  variant="subtitle1"
                  align="center"
                  style={{ color: "white" }}
                >
                  Please enter the 6 digit code we just emailed to you. It may
                  take a few moments to arrive. Please check your spam folder as
                  well.
                </Typography>
              </Grid>
              {error ? (
                <Grid
                  item
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Typography
                    variant="subtitle2"
                    style={{ color: "#e6ff02", padding: 20 }}
                  >
                    {error}
                  </Typography>
                </Grid>
              ) : (
                <></>
              )}
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "90%" }}>
                  <label
                    htmlFor="email-input"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 12,
                      color: "#fff",
                      fontSize: "0.9rem",
                    }}
                  >
                    Email / Username
                  </label>
                  <input
                    id="email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="authInput"
                  />
                </div>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "90%" }}>
                  <label
                    htmlFor="code-input"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 12,
                      color: "#fff",
                      fontSize: "0.9rem",
                    }}
                  >
                    6 digit code
                  </label>
                  <input
                    id="code-input"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="######"
                    className="authInput"
                  />
                </div>
                {codeError ? (
                  <Typography style={{ color: "#e6ff02", marginTop: 10 }}>
                    Invalid code. Please try again
                  </Typography>
                ) : null}
              </Grid>
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "90%", position: "relative" }}>
                  <label
                    htmlFor="password-input"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 12,
                      color: "#fff",
                      fontSize: "0.9rem",
                    }}
                  >
                    Enter a new password
                  </label>
                  <input
                    id="password-input"
                    type={passwordVisibility ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Your password"
                    className="authInput"
                    style={{
                      paddingRight: "40px", // leave space on the right for the eye icon
                    }}
                    autoComplete="off"
                  />
                  <div
                    onClick={() => setPasswordVisibility(!passwordVisibility)}
                    style={{
                      position: "absolute",
                      right: 16,
                      top:52 /* roughly halfway down the input + label spacing */,
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  >
                    {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                  </div>
                </div>
              </Grid>
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "90%", position: "relative" }}>
                  <label
                    htmlFor="password-input"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 12,
                      color: "#fff",
                      fontSize: "0.9rem",
                    }}
                  >
                    Re-enter your new password
                  </label>
                  <input
                    id="password-input2"
                    type={passwordVisibility ? "text" : "password"}
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                    placeholder="Your password"
                    className="authInput"
                    style={{
                      paddingRight: "40px", // leave space on the right for the eye icon
                    }}
                    autoComplete="off"
                  />
                  <div
                    onClick={() => setPasswordVisibility(!passwordVisibility)}
                    style={{
                      position: "absolute",
                      right: 16,
                      top: 52 /* roughly halfway down the input + label spacing */,
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  >
                    {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                  </div>
                </div>
              </Grid>
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  style={{
                    width: "90%",
                    height: 40,
                    backgroundColor: "#e6ff02",
                    color: "#252b20",
                  }}
                  onClick={handleReset}
                >
                  reset
                </Button>
              </Grid>

              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  style={{
                    width: "90%",
                    height: 40,
                    color: "#e6ff02",
                  }}
                  onClick={() => setPage("login")}
                >
                  back to login
                </Button>
              </Grid>
              <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
                <Typography
                  variant="subtitle2"
                  align="center"
                  style={{ paddingLeft: 10, paddingRight: 10, color: "white" }}
                >
                  Don't have an account? Click{" "}
                  <span
                    onClick={() =>
                      window.open("https://thenextfunmatch.com", "_blank")
                    }
                    style={{
                      color: "#e6ff02",
                      cursor: "pointer",
                    }}
                  >
                    here
                  </span>{" "}
                  to get in touch.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography align="center" style={{ color: "#353535" }}>
              &copy; Aisle 2 LLC All Rights Reserved
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              align="center"
              style={{ color: "#353535" }}
              // onClick={() => window.open(appConfig?.privacyPolicy, "_blank")}
            >
              Privacy Policy
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConfirmForgot;
